import Vue from 'vue';
import store from '@/store';
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";
import queryUtil from '@/util/query.util';
import {ReceberFilter} from "@/models/cliente/receber-filter.interface";
import ReceberResponse from "@/models/receber-response";
import ReceberFilterModel from "@/models/cliente/receber-filter.model";

class ReceberService {

    STATUS_OK: number = 200;

    async localizar(filtro: ReceberFilter | ReceberFilterModel | undefined): Promise<any> {
        const query = queryUtil.getQuery(filtro);
        return await Vue.prototype.$axios.get(`filter/contas-receber${query}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const retorno: ReceberResponse = response.data;
                    if (retorno.itens.length === 0) {
                        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Nenhum título ou nota foi localizado');
                    }
                    return retorno;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao localizar a lista de títulos ou nota');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

}

export default new ReceberService();
